export const setEditPortletData = (valObj) => {
  return {
    type: 'SET_EDIT_PORTLET_DATA',
    data: valObj
  }
}


// WEBPACK FOOTER //
// ./src/actions/EditPortletDataActions.js